// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"

import './assets/bootstrap.min.css'
import './assets/bootstrap-vue.min.css'
import './assets/iransansweb.min.css'

import App from './App'
import router from './router'
import Meta from 'vue-meta'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VeeValidate from 'vee-validate';
import messages from 'vee-validate/dist/locale/fa'


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCCtbsCClJNDJF9a8hM6rt5mr-i5rR5ncc',
        libraries: 'places',
    },
});
Vue.use(VeeValidate, {
    locale: 'fa',
    dictionary: {
        fa: messages
    }
});

Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.use(Meta)

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueAuth from '@websanova/vue-auth'
//Vue.component('icon', Icon)

import './assets/icons/css/font-awesome.min.css'


import VueAutosuggest from "vue-autosuggest";

Vue.use(VueAutosuggest);

//axios.defaults.baseURL = 'https://api.khezal.com/admin/';
axios.defaults.baseURL = 'http://127.0.0.1:8000/admin/';
axios.defaults.baseURL = 'http://api.khezal.host2000.ir/admin/';
Vue.use(VueAxios, axios)

Vue.router = router;
Vue.use(require('vue-moment-jalaali'));


Vue.filter('commas', function (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('rial', function (value) {
    return value.toString() + " ریال ";
});


Vue.filter('orderStatus', function (value) {
    switch (value) {


        case 'ordered':
            return 'ثبت شده';
            break;
        case 'canceled':
            return 'لغو شده';
            break;
        case 'paid':
            return 'پرداخت شده';
            break;
        case 'posted':
            return 'ارسال شده';
            break;
        case 'delivered':
            return 'تحویل شده';
            break;
    }
});


Vue.use(VueAuth, {
    auth: {
        request: function (req, token) {
            this.options.http._setHeaders.call(this, req, {
                Authorization: 'Bearer ' + token
            });
        },
        response: function (res) {
			console.log(res)
            return res.data.token;
        }
    },
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    loginData: {url: 'fa/v1/auth/login', method: 'POST', redirect: '/', fetchUser: true},
    fetchData: {url: 'fa/v1/auth/user', method: 'GET', enabled: true},
    refreshData: {url: 'fa/v1/auth/refresh', method: 'GET', enabled: true, interval: 30},
    logoutData: {url: 'fa/v1/auth/logout', method: 'POST', redirect: '/', makeRequest: false}

});




/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
})



// WEBPACK FOOTER //
// ./src/main.js